'use strict';

import $ from 'jquery';
import Hls from 'hls.js';

$(function(){
  get_cloudfront_url('login_video');
  get_cloudfront_url('create_team_video');

  function show_video(cloudfront_url, id) {
    const video = document.getElementById(id);
    const video_src = cloudfront_url;
    // hls.jsがcookieをcloudfrontに送るために必要
    const config = {
      // eslint-disable-next-line no-unused-vars
      xhrSetup: function(xhr, url) {
        xhr.withCredentials = true;
      }
    }

    if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = video_src;
    } else if (Hls.isSupported()) {
      const hls = new Hls(config);
      hls.loadSource(video_src);
      hls.attachMedia(video);
    }
  }

  function get_cloudfront_url(id){
    const api_url = $('#API_V1_CLOUDFRONT_SIGNED_COOKIE_PATH').val();
    const key_value = $(`#${id}_key`).val();
    const auth_api_token = $("input[type=hidden][name=api_token]").val();
    const params = {
      file_key: key_value,
      api_token: auth_api_token
    }

    $.ajax(
      api_url,
      {
        method: 'get',
        cache: false,
        async: true,
        processData: true,
        contentType: false,
        data: params,
        dataType: 'json',
        success: function( data ){
          show_video(data.cloudfront_url, id)
        },
        error: function( /* XMLHttpRequest, textStatus, errorThrown */ ){
          console.log('failed.')
        }
      });
  }
})
